<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <span>
    {{ item }}
    <span
      v-if="applications > 1"
      class="candidate-again"
      :title="`Applied ${applications} times by email`"
    >
      ×{{ applications }}
    </span>
  </span>
</template>

<script>
// Candidate list cell: the name, and "×N" when they applied by email N times.
export default {
  name: 'CandidateNameCell',
  props: {
    item: {
      type: String,
      required: true,
    },
    applications: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss" scoped>
.candidate-again {
  margin-left: 6px;
  padding: 1px 7px;
  border-radius: 999px;
  background: #eaf2fb;
  color: #1f5fa8;
  font-size: 11px;
  font-weight: 700;
}
</style>
